@use '@/sass/variables';
@use '@/sass/utils/mixins';

.tagSearchBar {
  box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.05);
  height: mixins.rem(40px);
  vertical-align: baseline;
  min-width: mixins.rem(75px);
  border-radius: 0 3px 3px 0;
  padding-left: mixins.rem(32px);
  cursor: text;
}
